var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMap = function SvgMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.092 5.969a.3.3 0 0 0 .109-.022l4.541-1.817a1.82 1.82 0 0 1 1.349 0l4.267 1.707c.69.275 1.142.944 1.142 1.687v10.214a1.282 1.282 0 0 1-1.76 1.198l-4.206-1.68a.3.3 0 0 0-.112-.023h-.011a.3.3 0 0 0-.112.023l-4.541 1.817a1.82 1.82 0 0 1-1.349 0l-4.267-1.707A1.82 1.82 0 0 1 3 15.679V5.462a1.282 1.282 0 0 1 1.76-1.198l4.206 1.683a.3.3 0 0 0 .109.022zm-.759 1.34L4.5 5.776v9.903c0 .13.079.246.199.294l3.634 1.454zm1.5 0v10.118l3.834-1.534V5.776zm5.334-1.533v10.117L19 17.423v-9.9a.32.32 0 0 0-.199-.294z",
    clipRule: "evenodd"
  })));
};
export default SvgMap;